
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-agents",
      function () {
        return require("private-next-pages/for-agents.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-agents"])
      });
    }
  